(function () {
    'use strict';

    angular
        .module('garnaCabinet')
        .factory('Project', Project);

    Project.$inject = ['$resource'];

    /* @ngInject */
    function Project($resource) {
        return $resource('api/order/:projectId',
            {projectId: '@id'},
            {
                'update': {method:'PUT', isArray:true}
            }
        );
    }

})();

